import {
  UilBooks,
  UilInvoice,
  UilRefresh,
  UilExclamationTriangle
} from '@iconscout/react-unicons';

export const buildSalesStats = stats => [
  {
    title: 'Total Orders',
    count: stats?.totalOrders ?? 0,
    icon: UilBooks,
    iconColor: 'primary',
    subtitle: 'All orders'
  },
  {
    title: 'Active',
    count: stats?.activeOrders ?? 0,
    icon: UilInvoice,
    iconColor: 'warning',
    subtitle: 'In progress'
  },
  {
    title: 'Pending',
    count: stats?.pendingOrders ?? 0,
    icon: UilRefresh,
    iconColor: 'info',
    subtitle: 'Awaiting processing'
  },
  {
    title: 'Deadline',
    count: stats?.closeToDeadline ?? 0,
    icon: UilExclamationTriangle,
    iconColor: 'danger',
    subtitle: 'Due within 7 days'
  }
];
